/** @format */
import angular from 'angular';
import _ from 'lodash';
import { ValidationErrorHandlerService } from '../error-handler/validation-error-handler.service';

export const bulkEditUtilsModule = 'sis-components.bulkedit.bulkEditUtils';

(function () {
    bulkEditUtils.$inject = [
        '$log',
        '$q',
        'ValidationPhase',
        'ValidationResponse',
        'validationErrorHandler',
        'jsDataCacheHelper',
        'bulkEditStore',
        'courseUnitJSDataModel',
        'studyModuleJSDataModel',
        'degreeProgrammeJSDataModel',
    ];
    angular
        .module(bulkEditUtilsModule, [
            'sis-components.bulkedit.validationResult',
            'sis-components.bulkedit.bulkEditService',
            'sis-components.service.jsDataCacheHelper',
            'sis-components.model.courseUnit',
            'sis-components.model.studyModule',
            'sis-components.model.degreeProgramme',
            ValidationErrorHandlerService.downgrade.moduleName,
        ])
        .service('BulkEditUtils', bulkEditUtils);

    function bulkEditUtils(
        $log,
        $q,
        ValidationPhase,
        ValidationResponse,
        validationErrorHandler, // NOSONAR
        jsDataCacheHelper,
        bulkEditStore,
        courseUnitJSDataModel,
        studyModuleJSDataModel,
        degreeProgrammeJSDataModel,
    ) {
        function handleBackEndValidation(request, objectIndex, validationResult) {
            validationResult.status = ValidationPhase.NOT_READY;

            return request().then(
                response => {
                    const results = response.data;
                    _.forEach(_.keys(results), studyId => {
                        const study = objectIndex[studyId];
                        const result = results[studyId];

                        if (result.resultCode === 'FORBIDDEN') {
                            validationResult.addError(study, ValidationResponse.BACK_END_FORBIDDEN);
                        } else if (result.resultCode === 'VALIDATION_ERROR') {
                            const validationErrors = validationErrorHandler.parseViolations(result.errorDetails);

                            if (
                                _.size(validationErrors) === 1 &&
                                validationErrors[0] === 'valdr.{fi.helsinki.otm.kori.validation.duplicateCurriculumPeriodId}'
                            ) {
                                validationResult.addError(study, ValidationResponse.VALIDATION_ALREADY_IN_CURRICULUMPERIOD);
                            } else {
                                _.forEach(validationErrors, validationError => {
                                    let details;
                                    if (
                                        validationError.messageKey === 'valdr.{fi.helsinki.otm.kori.validation.duplicateCurriculumPeriodId}'
                                    ) {
                                        details = validationResult.addError(
                                            study,
                                            ValidationResponse.VALIDATION_ALREADY_IN_CURRICULUMPERIOD,
                                        );
                                    } else {
                                        details = validationResult.addError(study, ValidationResponse.BACK_END_VALIDATION_ERROR);
                                    }
                                    if (validationError.messageKey && _.isEmpty(validationError.fieldKeys)) {
                                        details.addDetail('', validationError.messageKey);
                                    }
                                    _.forEach(validationError.fieldKeys, fieldKey => {
                                        details.addDetail(`FIELD_NAMES.${fieldKey}`, validationError.messageKey);
                                    });
                                });
                            }
                        } else if (result.resultCode === 'NOT_FOUND') {
                            validationResult.addError(study, ValidationResponse.BACK_END_NOT_FOUND);
                        }
                    });
                    validationResult.status = ValidationPhase.READY;
                },
                () => {
                    validationResult.status = ValidationPhase.FAILED;
                },
            );
        }

        function loadStudies(jsDataModel, studyIds, options) {
            if (!jsDataModel) {
                $log.warn('ApprovalService > Trying to load studies when jsDataModel is not defined.');
                return $q.when([]);
            }
            return jsDataCacheHelper.findByIds(jsDataModel, studyIds).then(studies => {
                studies = _.orderBy(studies, ['approvalState', 'name']);

                options.selectedIds = _.map(studies, study => {
                    study.selected = true;
                    return study.id;
                });

                return studies;
            });
        }

        function findStoredStudies(idKey, modelKey, serviceApi, options) {
            const studyIdArray = bulkEditStore.get(idKey);
            const jsDataModelName = bulkEditStore.get(modelKey);

            if (jsDataModelName === courseUnitJSDataModel.name) {
                serviceApi.jsDataModel = courseUnitJSDataModel;
            } else if (jsDataModelName === studyModuleJSDataModel.name) {
                serviceApi.jsDataModel = studyModuleJSDataModel;
            } else if (jsDataModelName === degreeProgrammeJSDataModel.name) {
                serviceApi.jsDataModel = degreeProgrammeJSDataModel;
            }

            if (serviceApi.jsDataModel && studyIdArray && studyIdArray.length > 0) {
                return api.loadStudies(serviceApi.jsDataModel, studyIdArray, options); // NOSONAR
            }
            return $q.when([]);
        }

        const api = {
            handleBackEndValidation,
            loadStudies,
            findStoredStudies,
        };

        return api;
    }
})();
